module.exports = {
  // 设置cookie
  set: function (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
  },
  // 获取cookie
  get: function (c_name) {
    var arr, reg = new RegExp("(^| )" + c_name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return (arr[2]);
    else
      return null;
  },
  remove: function (c_name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.get(c_name);
    if (cval != null)
      document.cookie = c_name + "=" + cval + ";expires=" + exp.toGMTString();
  }
}
